import React, { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Input, Label, Button, Card, CardBody, Modal, ModalHeader, FormFeedback, ModalBody, ModalFooter, Media } from 'reactstrap';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { BackendAPI } from '../../api';
import SweetAlert from 'sweetalert2';
// import { Input } from 'antd';
import { Breadcrumbs } from '../../AbstractElements';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { Field, Form } from 'react-final-form'; // Import Field and Form from react-final-form
import { required, email, name, Img, PDF } from '../Utils/validationUtils';

import useAuth from '../../Auth/protectedAuth';
import { getToken } from '../../Auth/Auth';



//Utility function used to combine multiple validation functions into a single validation function
const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined);

const EditUser = () => {
    useAuth();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState(false);
    const [fieldLabels, setFieldLabels] = useState([]);
    const [fieldType, setFieldType] = useState([]);
    const [requiredfield, setRequiredField] = useState([]); // Define requiredfield state
    const [fieldId, setFieldId] = useState([]);
    const [fieldName, setFieldName] = useState([]);
    const navigate = useNavigate(); // Initialize useHistory
    const [prefixes, setPrefixes] = useState([]);
    const [state, setState] = useState([]);
    const [country, setCountry] = useState([]);
    const [regCat, setRegCat] = useState([]);
    const [workshop, setWorkshop] = useState([]);
    const [User, setUser] = useState([]);
    const [dayType, setDayType] = useState([]);
    const [custom, setCustom] = useState([]);
    const location = useLocation();
    const { catId } = location.state;

    console.log(User);


    useEffect(() => {
        fetchUserDetail(); // Fetch workshop data when component mounts
    }, []);

    const fetchUserDetail = async () => {
        try {
            const token = getToken();
            const response = await axios.post(`${BackendAPI}/manageuser/fetchuserdetail`, { catId }, {
                headers: {
                    Authorization: `Bearer ${token}` // Include the token in the Authorization header
                }
            });
            // console.log('Data from API:', response.data);
            setUser(response.data[0]); // Set workshop data to the first item in the response array
        } catch (error) {
            console.error('Error fetching user detail data:', error);
        }
    };

    useEffect(() => {
        fetchFields(); // Corrected function name
    }, []);

    useEffect(() => {
        fetchDropdown(); // Corrected function name
    }, []);

    const fetchFields = async () => {
        try {
            const token = getToken();
            const response = await axios.get(`${BackendAPI}/manageuser/getField`, {
                headers: {
                    Authorization: `Bearer ${token}` // Include the token in the Authorization header
                }
            });
            const fieldsData = response.data.Fields;
            const requiredfield = fieldsData.map(field => field.cs_is_required);
            const fieldLabels = fieldsData.map(field => field.cs_field_label);
            const fieldType = fieldsData.map(field => field.field_type_name);
            const fieldId = fieldsData.map(field => field.cs_field_id);
            const fieldName = fieldsData.map(field => field.cs_field_name);

            setData(fieldsData);
            setFieldLabels(fieldLabels);
            setFieldType(fieldType);
            setFieldName(fieldName);
            setRequiredField(requiredfield); // Set requiredfield state
            setFieldId(fieldId);
            setLoading(false);

            // console.log('Id:', fieldName);
        } catch (error) {
            console.error('Error fetching Fields:', error);
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setModal(true);
    };

    const onSubmit = async (formData) => {
        try {
            const id = catId;
            console.log("id", id);

            const values = {};
            for (const key in formData) {
                if (Object.hasOwnProperty.call(formData, key)) {
                    values[key] = formData[key].value || formData[key];
                }
            }

            // Add catId to the values object
            values.cs_regno = id;
            const token = getToken();
            await axios.post(`${BackendAPI}/manageuser/editUser`, values, {
                headers: {
                    Authorization: `Bearer ${token}` // Include the token in the Authorization header
                }
            });

            SweetAlert.fire({
                title: 'Success!',
                text: 'User data updated successfully !',
                icon: 'success',
                timer: 3000,
                showConfirmButton: false
            }).then((result) => {
                if (result.dismiss === SweetAlert.DismissReason.timer) {
                    navigate("/User-listing/Consoft");
                }
            });
        } catch (error) {
            console.error('Error creating application login:', error.message);
        }
    };







    const fetchDropdown = async () => {
        try {
            const token = getToken();
            const response = await axios.get(`${BackendAPI}/manageuser/getDropdownData`, {
                headers: {
                    Authorization: `Bearer ${token}` // Include the token in the Authorization header
                }
            });
            setData(response.data);
            // console.log(response.data);
            setLoading(false);

            const fetchprefixes = response.data.prefix;
            const fetchstate = response.data.states;
            const fetchcountry = response.data.country;
            const fetchregcat = response.data.regCategory;
            const fetchworkshop = response.data.workshop;
            const fetchdaytype = response.data.dayType;
            const fetchCutomData = response.data.custom;


            setPrefixes(fetchprefixes);
            setState(fetchstate);
            setCountry(fetchcountry);
            setRegCat(fetchregcat);
            setWorkshop(fetchworkshop);
            setDayType(fetchdaytype);
            setCustom(fetchCutomData);


            // console.log(fetchprefixes);


        } catch (error) {
            console.error('Error fetching dropdown data:', error);
            setLoading(false);
        }
    };



    return (
        <Fragment>
            <Breadcrumbs mainTitle="Create User" parent="Manage User" title="Create User" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <Form onSubmit={onSubmit}>
                                    {({ handleSubmit }) => (
                                        <form className='needs-validation' noValidate='' onSubmit={handleSubmit}>
                                            {/* Render multiple Field components based on the length of fieldLabels array */}
                                            {fieldLabels.map((label, index) => {
                                                const isFieldRequired = requiredfield[index] === 1;
                                                return (
                                                    <Row key={index}>
                                                        <Col md="4" className="mb-3">
                                                            {/* {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'Title' && (
                                                               <Field
                                                               name={`${fieldName[index]}`} // Use dynamic field name
                                                               initialValue={User.cs_title || ''}
                                                               validate={requiredfield[index] === '1' ? composeValidators(required) : (value) => composeValidators()(value)}
                                                           >
                                                               {({ input, meta }) => {
                                                                   // Find the option corresponding to User.cs_title
                                                                   const selectedOption = prefixes.find(option => option.cs_prefix === User.cs_title);
                                                                   console.log('selectedOption', selectedOption);
                                                                   const formattedSelectedOption = selectedOption ? { value: selectedOption.cs_prefix, label: selectedOption.cs_prefix } : null;
                                                                   return (
                                                                    <div>
                                                                      <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                      <Select
                                                                        {...input}
                                                                        options={prefixes.map(pref => ({ value: pref.cs_prefix, label: pref.cs_prefix }))}
                                                                        placeholder={`Select ${label}`}
                                                                        isSearchable={true}
                                                                        onChange={(value) => input.onChange(value.value)} // Handle change correctly
                                                                        onBlur={input.onBlur}
                                                                        classNamePrefix="react-select"
                                                                        value={formattedSelectedOption} // Set the selected option correctly
                                                                      />
                                                                      {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                    </div>
                                                                  );
                                                               }}
                                                           </Field>
                                                           
                                                           
                                                            )} */}

                                                            {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'Title' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User.cs_title || ''}
                                                                    validate={requiredfield[index] === '1' ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        // Find the option corresponding to User.cs_title
                                                                        const selectedOption = prefixes.find(option => option.cs_prefix === User.cs_title);

                                                                        // Map prefixes to create the options array
                                                                        const options = prefixes.map(pref => ({
                                                                            value: pref.cs_prefix,
                                                                            label: pref.cs_prefix,
                                                                        }));

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        input.onChange(selectedOption ? selectedOption.value : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={options.find(option => option.value === input.value) || null} // Set the value directly to the initialValue
                                                                                />
                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            )}


                                                            {/* {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'State' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User.cs_state || ''}
                                                                    validate={requiredfield[index] === '1' ? composeValidators(required) : (value) => composeValidators()(value)}

                                                                >
                                                                    {({ input, meta }) => (
                                                                        <div>
                                                                            <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                            <Select
                                                                                {...input}
                                                                                options={state.map(pref => ({ value: pref.cs_state_name, label: pref.cs_state_name }))}
                                                                                placeholder={`Select ${label}`}
                                                                                isSearchable={true}
                                                                                onChange={(value) => input.onChange(value)}
                                                                                onBlur={input.onBlur}
                                                                                classNamePrefix="react-select"
                                                                            />
                                                                            {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            )} */}

                                                            {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'State' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User.cs_state || ''}
                                                                    validate={isFieldRequired ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        // Find the option corresponding to User.cs_state
                                                                        const selectedOption = state.find(option => option.cs_state_name === User.cs_state);

                                                                        // Map state to create the options array
                                                                        const options = state.map(pref => ({
                                                                            value: pref.cs_state_name,
                                                                            label: pref.cs_state_name,
                                                                        }));

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        input.onChange(selectedOption ? selectedOption.value : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={options.find(option => option.value === input.value) || null} // Set the value directly to the initialValue
                                                                                />
                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>

                                                            )}
                                                            {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'Country' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User.cs_country || ''}
                                                                    validate={isFieldRequired ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        const selectedOption = country.find(option => option.cs_country === User.cs_country);
                                                                        const options = country.map(pref => ({
                                                                            value: pref.cs_country,
                                                                            label: pref.cs_country,
                                                                        }));

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        input.onChange(selectedOption ? selectedOption.value : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={options.find(option => option.value === input.value) || null}
                                                                                />
                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            )}
                                                            {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'Workshop Category' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User.cs_workshop_category || ''}
                                                                    validate={isFieldRequired ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        // Ensure that the initial value is parsed as an integer
                                                                        const initialValue = parseInt(input.value, 10);

                                                                        // Find the selected option based on the initial value
                                                                        const selectedOption = workshop.find(option => option.cs_workshop_id === initialValue);

                                                                        // Map options to the format expected by react-select
                                                                        const options = workshop.map(pref => ({
                                                                            value: pref.cs_workshop_id,
                                                                            label: pref.cs_workshop_name,
                                                                        }));

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' for={`displayname${index}`}>
                                                                                    <strong>{label}</strong>
                                                                                </Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        // Ensure the selected value is passed as a string
                                                                                        input.onChange(selectedOption ? selectedOption.value.toString() : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={options.find(option => option.value === initialValue) || null}
                                                                                />
                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            )}

                                                            {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'Registration Category' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User.cs_reg_cat_id || ''}
                                                                    validate={isFieldRequired ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        const selectedOption = regCat.find(option => option.cs_reg_cat_id === User.cs_reg_category);





                                                                        const options = regCat.map(pref => ({
                                                                            value: pref.cs_reg_cat_id,
                                                                            label: pref.cs_reg_category,
                                                                        }));

                                                                        console.log("Selected  Registration Option:", selectedOption);
                                                                        console.log("Registration Options:", options);

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        input.onChange(selectedOption ? selectedOption.value : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={options.find(option => option.value === input.value) || null}
                                                                                />
                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            )}


                                                            {/* //---------------  */}



                                                            {/* {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'Registration Type' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User.cs_reg_type || ''}
                                                                    validate={isFieldRequired ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        // Convert User.cs_reg_type to number
                                                                        const regType = parseInt(User.cs_reg_type);

                                                                        // Find the selected option based on the converted number
                                                                        const selectedOption = dayType.find(option => option.cs_reg_daytype_id === regType);

                                                                        // Map options
                                                                        const options = dayType.map(pref => ({
                                                                            value: pref.cs_reg_daytype_id,
                                                                            label: pref.cs_reg_daytype_name,
                                                                        }));

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' htmlFor={`displayname${index}`}><strong>{label}</strong></Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        console.log("Dropdown value changed:", selectedOption); // Add debug logging
                                                                                        input.onChange(selectedOption ? selectedOption.value : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={selectedOption || null} // Set the value to the selected option object
                                                                                />

                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            )} */}



                                                            {fieldType[index] === 'Dropdown' && fieldLabels[index] === 'Registration Type' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`}
                                                                    initialValue={User.cs_reg_type || ''}
                                                                    validate={isFieldRequired ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        // Parse the initial value to ensure it's a number
                                                                        const initialValue = parseInt(input.value, 10);

                                                                        // Map options to the format expected by react-select
                                                                        const options = dayType.map(pref => ({
                                                                            value: pref.cs_reg_daytype_id,
                                                                            label: pref.cs_reg_daytype_name,
                                                                        }));

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' for={`displayname${index}`}>
                                                                                    <strong>{label}</strong>
                                                                                </Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        // Ensure that the selected value is converted to number
                                                                                        input.onChange(selectedOption ? selectedOption.value.toString() : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={options.find(option => option.value === initialValue) || null}
                                                                                />
                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>

                                                            )}


                                                            {fieldType[index] === 'Dropdown' && fieldId[index] > 23 && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User[fieldName[index]] || ''} // Set initial value based on User data
                                                                    validate={requiredfield[index] === '1' ? composeValidators(required) : undefined}
                                                                >
                                                                    {({ input, meta }) => {
                                                                        // Filter fetchCustomData based on matching cs_field_id with fieldId
                                                                        const matchedOptions = custom.filter(option => option.cs_field_id === fieldId[index]);
                                                                        console.log('matchedOptions', matchedOptions);

                                                                        // Determine the selected option
                                                                        const selectedOption = matchedOptions.find(option => option.cs_field_option_value === User[fieldName[index]]);

                                                                        console.log('selectedOption', selectedOption);

                                                                        // Map matchedOptions to the format expected by react-select
                                                                        const options = matchedOptions.map(option => ({
                                                                            value: option.cs_field_option_value,
                                                                            label: option.cs_field_option,
                                                                        }));

                                                                        // Set the selected option in the format expected by react-select
                                                                        const currentValue = options.find(option => option.value === input.value);

                                                                        return (
                                                                            <div>
                                                                                <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                                <Select
                                                                                    {...input}
                                                                                    options={options}
                                                                                    placeholder={`Select ${label}`}
                                                                                    isSearchable={true}
                                                                                    onChange={(selectedOption) => {
                                                                                        input.onChange(selectedOption ? selectedOption.value : '');
                                                                                    }}
                                                                                    onBlur={input.onBlur}
                                                                                    classNamePrefix="react-select"
                                                                                    value={currentValue || null} // Ensure correct current value
                                                                                />
                                                                                {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            )}










                                                            {fieldType[index] === 'Long Text' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User[fieldName[index]] || ''}
                                                                    validate={isFieldRequired ? composeValidators(required, name) : name}
                                                                >
                                                                    {({ input, meta }) => (
                                                                        <div>
                                                                            <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                            <textarea
                                                                                {...input}
                                                                                className="form-control"
                                                                                id={`displayname${index}`}
                                                                                placeholder={`Enter ${label}`}
                                                                            />
                                                                            {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            )}

                                                            {fieldType[index] === 'Number' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`} // Use dynamic field name
                                                                    initialValue={User[fieldName[index]] || 'sdgfdgd'}
                                                                    validate={isFieldRequired ? composeValidators(required, name) : name}
                                                                >
                                                                    {({ input, meta }) => (
                                                                        <div>
                                                                            <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                            <input
                                                                                {...input}
                                                                                className="form-control"
                                                                                id={`displayname${index}`}
                                                                                type="number"
                                                                                placeholder={`Enter ${label}`}
                                                                            />
                                                                            {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            )}

                                                            {fieldType[index] === 'Text' && (
                                                                <Field
                                                                    name={`${fieldName[index]}`}
                                                                    initialValue={User[fieldName[index]] || 'sdgfdgd'}
                                                                    validate={isFieldRequired ? composeValidators(required, name) : name}
                                                                >
                                                                    {({ input, meta }) => (
                                                                        <div>
                                                                            <Label className='form-label' for={`displayname${index}`}><strong>{label}</strong></Label>
                                                                            <input
                                                                                {...input}
                                                                                className="form-control"
                                                                                id={`displayname${index}`}
                                                                                type="text"
                                                                                placeholder={`Enter ${label}`}
                                                                            />
                                                                            {meta.error && meta.touched && <p className='d-block text-danger'>{meta.error}</p>}
                                                                        </div>
                                                                    )}
                                                                </Field>

                                                            )}
                                                        </Col>
                                                    </Row>
                                                );
                                            })}

                                            <div>
                                                <Button color='primary' type='submit' className="me-3 mt-3">Edit User</Button>
                                                <Button color='warning' onClick={handleCancel} className="mt-3">Cancel</Button>
                                            </div>
                                        </form>
                                    )}
                                </Form>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {/* Modal */}
            <Modal isOpen={modal} toggle={() => setModal(!modal)} centered>
                <ModalHeader toggle={() => setModal(!modal)}>Confirm Cancel</ModalHeader>
                <ModalBody>
                    Your changes will be discarded. Are you sure you want to cancel?
                </ModalBody>
                <ModalFooter>
                    <Link to="/manage-facility/Consoft" className="btn btn-warning">Yes</Link>
                    <Button color="primary" onClick={() => setModal(!modal)}>No</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default EditUser;